import { Box, Typography, styled } from '@mui/material'
import ErrorLogo from '@/assets/error.svg'

interface ErrorPageProps {
    title?: string;
    message?: string;
}

export const ErrorPage = ({title, message}: ErrorPageProps) => {
  return (
    <EmptyContainer>
      <Box component="img" src={ErrorLogo} alt="Search Icon" mb={2} />
       <Title>{title ?? "Something went wrong. Please try again later!"}</Title>
      <Message>{message ?? ""}</Message>
    </EmptyContainer>
  )
}

const EmptyContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  border: `1px solid #E4E7EC`,
  borderRadius: '8px',
  padding: '5rem 0',
})

const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
    fontWeight: 600,
  fontSize: '0.9rem',
  paddingBottom: theme.spacing(3),
}))

const Message = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
  fontSize: '14px',
  fontWeight: 500,
  maxWidth: 600,
  textAlign: 'center',
}))
